"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownIndicator = exports.ValueContainer = exports.IndicatorSeparator = exports.SelectActionType = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var react_select_1 = __importStar(require("react-select"));
var styles_1 = require("./styles");
var InputLabel_1 = require("../Input/InputLabel");
var Option_1 = require("./Option");
var __1 = require("..");
var drop_svg_1 = __importDefault(require("./assets/drop.svg"));
var MultiValueList_1 = require("./MultiValueList");
var react_2 = require("@emotion/react");
var SelectActionType;
(function (SelectActionType) {
    SelectActionType["SELECT_OPTION"] = "select-option";
    SelectActionType["DESELECT_OPTION"] = "deselect-option";
})(SelectActionType = exports.SelectActionType || (exports.SelectActionType = {}));
var getCSSRules = function (_a) {
    var colors = _a.colors;
    return ({
        valueCount: {
            backgroundColor: colors.Green[600],
            color: colors.Grey[0],
            width: 28,
            height: 22,
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            borderRadius: 50,
            flexShrink: 0,
        },
        valueContainer: {
            display: 'flex',
            flexWrap: 'nowrap',
            position: 'relative',
        },
        root: {},
        dropIcon: {
            marginRight: 11,
            width: 12,
            height: 12,
        },
        dropIconDisabled: {
            opacity: 0.5,
        },
        pill: {
            paddingLeft: 12,
            paddingRight: 12,
            marginLeft: 4,
            borderRadius: 16,
            color: colors.Grey[100],
            backgroundColor: colors.Green[600],
        },
        disabled: {
            color: colors.Grey[400],
        },
    });
};
var IndicatorSeparator = function () {
    return (0, jsx_runtime_1.jsx)("span", {}, void 0);
};
exports.IndicatorSeparator = IndicatorSeparator;
var ValueContainer = function (props) {
    var children = props.children, selectProps = props.selectProps, getValue = props.getValue, className = props.className;
    var menuIsOpen = selectProps.menuIsOpen;
    var theme = (0, react_2.useTheme)();
    var styles = getCSSRules(theme);
    var value = getValue();
    var count = (0, react_1.useMemo)(function () {
        return value.length;
    }, [value, menuIsOpen]);
    return ((0, jsx_runtime_1.jsx)(react_2.ClassNames, { children: function (_a) {
            var cx = _a.cx, css = _a.css;
            return ((0, jsx_runtime_1.jsxs)(react_select_1.components.ValueContainer, __assign({}, props, { getValue: getValue, selectProps: selectProps, className: cx(className, css(styles.valueContainer)) }, { children: [children, !!count && ((0, jsx_runtime_1.jsx)("div", __assign({ css: styles.valueCount }, { children: (0, jsx_runtime_1.jsx)(__1.Typography, __assign({ component: "div", variant: "textSmall" }, { children: count }), void 0) }), void 0))] }), void 0));
        } }, void 0));
};
exports.ValueContainer = ValueContainer;
var DropdownIndicator = function (props) {
    var theme = (0, react_2.useTheme)();
    var styles = getCSSRules(theme);
    return ((0, jsx_runtime_1.jsx)("img", { src: drop_svg_1.default, css: (0, react_2.css)(styles.dropIcon, props.isDisabled && styles.dropIconDisabled), alt: "drop icon" }, void 0));
};
exports.DropdownIndicator = DropdownIndicator;
var Select = function (props) {
    var onChange = props.onChange, value = props.value, label = props.label, required = props.required, className = props.className, alwaysShowCounter = props.alwaysShowCounter, styles = props.styles, placeholder = props.placeholder, showSelectAll = props.showSelectAll, selectAllLabel = props.selectAllLabel, options = props.options, rest = __rest(props, ["onChange", "value", "label", "required", "className", "alwaysShowCounter", "styles", "placeholder", "showSelectAll", "selectAllLabel", "options"]);
    var _a = (0, react_1.useState)(value), localValue = _a[0], setLocalValue = _a[1];
    var SELECT_ALL_OPTION = {
        value: 'all',
        label: selectAllLabel || 'Select All',
    };
    (0, react_1.useEffect)(function () {
        setLocalValue(value);
    }, [value]);
    var ValueContainer = (0, react_1.useMemo)(function () { return function (props) {
        return ((0, jsx_runtime_1.jsx)(MultiValueList_1.MultiValueList, __assign({}, props, { alwaysShowCounter: alwaysShowCounter, showSelectAll: showSelectAll }), void 0));
    }; }, [alwaysShowCounter]);
    var selectOptions = (0, react_1.useMemo)(function () {
        if (showSelectAll) {
            return __spreadArray([SELECT_ALL_OPTION], (options || []), true);
        }
        return options;
    }, [options === null || options === void 0 ? void 0 : options.length, showSelectAll]);
    var handleChangeMulti = function (value, actionMeta) {
        var action = actionMeta.action, option = actionMeta.option;
        var sanitizedValue = value
            ? value.filter(function (opt) { return opt.value !== SELECT_ALL_OPTION.value; })
            : [];
        var allSelected = sanitizedValue.length === (options || []).length;
        if (option && option.value === SELECT_ALL_OPTION.value) {
            if (action === SelectActionType.SELECT_OPTION) {
                allSelected = true;
            }
            if (action === SelectActionType.DESELECT_OPTION) {
                sanitizedValue = [];
                allSelected = false;
            }
        }
        var newValue = sanitizedValue;
        var newLocalValue = sanitizedValue;
        if (allSelected) {
            newValue = options || [];
            newLocalValue = __spreadArray([SELECT_ALL_OPTION], newValue, true);
        }
        setLocalValue(newLocalValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue, actionMeta);
    };
    var handleChange = function (value, actionMeta) {
        setLocalValue(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value, actionMeta);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: className }, { children: [label && (0, jsx_runtime_1.jsx)(InputLabel_1.InputLabel, __assign({ required: required }, { children: label }), void 0), (0, jsx_runtime_1.jsx)(react_select_1.default, __assign({ value: localValue, theme: function (theme) { return (__assign(__assign(__assign({}, theme), { colors: __assign({}, theme.colors) }), styles_1.selectThemeStyles)); }, components: props.isMulti
                    ? {
                        IndicatorSeparator: exports.IndicatorSeparator,
                        DropdownIndicator: exports.DropdownIndicator,
                        Option: Option_1.Option,
                        ValueContainer: ValueContainer,
                    }
                    : { IndicatorSeparator: exports.IndicatorSeparator, DropdownIndicator: exports.DropdownIndicator }, closeMenuOnSelect: !props.isMulti, controlShouldRenderValue: !props.isMulti, hideSelectedOptions: !props.isMulti, onChange: props.isMulti ? handleChangeMulti : handleChange, isClearable: false, styles: __assign(__assign({}, (0, react_select_1.mergeStyles)(styles_1.customStyles, styles)), { option: function (base) { return (__assign(__assign({}, base), { '& label': {
                            width: '100%',
                            '& div': {
                                display: 'block',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                            },
                        } })); } }), placeholder: placeholder, options: selectOptions }, rest), void 0)] }), void 0));
};
exports.default = Select;
//# sourceMappingURL=index.js.map